import React from "react";
import PropTypes, { InferProps } from "prop-types";
import clsx from "clsx";
import LinkWrapper from "../../LinkWrapper/LinkWrapper";
import classes from "./LinkButton.module.css";

LinkButton.propTypes = {
    link: PropTypes.string,
    desc: PropTypes.string,
    styleBtn: PropTypes.oneOf(["green", "transparent", "white"]),
    className: PropTypes.string,
    disabled: PropTypes.bool,
    animate: PropTypes.bool,
};

export default function LinkButton({
    link,
    desc,
    styleBtn,
    className,
    disabled,
    animate,
}: InferProps<typeof LinkButton.propTypes>) {
    return (
        <LinkWrapper
            className={clsx(
                classes.linkBtn,
                classes[styleBtn],
                className,
                disabled && classes.linkBtnDisabled,
                animate && classes.linkBtnAnimate,
            )}
            link={disabled ? "" : link}>
            <span>{desc}</span>
        </LinkWrapper>
    );
}
